import { Language } from '~common/i18n';
import {
  arrayTranslations,
  mergeTranslations,
} from '~admin/view/components/create-event/helper/merge-translations.helper';
import { EventTimelineFormData } from '~admin/view/components/details/event-details/event-timeline-details/event-timeline-details.component';
import { EventTimelineItemFormData } from '~admin/view/components/details/event-details/event-timeline-details/event-timeline-item-fields.component';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { TranslationFormData } from '~admin/view/components/ui/form/fields/field-translation.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventTimelineGroupTranslationRequest } from '~client/model/admin/event-timeline-group-translation-request';
import { EventTimelineTranslationGroupRequestItem } from '~client/model/admin/event-timeline-translation-group-request-item';
import { EventTimelineTranslationRequestItem } from '~client/model/admin/event-timeline-translation-request-item';
import { EventTranslationRequest } from '~client/model/admin/event-translation-request';
import { EventTimelineGroupResponse } from '~client/model/event-timeline-group-response';
import { isNilOrEmpty } from '~common/helper/global';

/**
 * Transforms EventTimelineDetailsFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventTimelineDetailsRequest = (
  values: EventFormData,
): Pick<EventProfileCreateRequest, 'eventTimelineGroups'> | null => {
  const { eventTimelineGroups } = values;

  if (isNilOrEmpty(eventTimelineGroups)) {
    return { eventTimelineGroups: null };
  }

  const eventTimelineGroupsRequest = eventTimelineGroups.map((group) => ({
    title: group.title[0].value,
    eventTimelineRequests: group.eventTimelineItems.map(({ title, rank, description }) => ({
      title: title[0].value,
      rank,
      description: description[0].value,
    })),
  }));

  return { eventTimelineGroups: eventTimelineGroupsRequest };
};

/**
 * Transforms TranslationFormData[] for Timeline Group Title to EventTimelineTranslationGroupRequestItem[]
 * @param title
 */
const getEventTimelineGroupTitleRequest = (
  title: TranslationFormData<string>[],
): EventTimelineTranslationGroupRequestItem[] => {
  const titleTranslations = new Map<Language, EventTimelineTranslationGroupRequestItem>();
  mergeTranslations(titleTranslations, 'title', title);
  return arrayTranslations(titleTranslations);
};

/**
 * Transforms EventTimelineItemFormData to EventTimelineTranslationRequestItem[]
 * @param item
 */
const getEventTimelineTranslationRequestItems = (
  item: EventTimelineItemFormData,
): EventTimelineTranslationRequestItem[] => {
  const { description, title } = item;

  const itemTranslations = new Map<Language, EventTimelineTranslationRequestItem>();
  mergeTranslations(itemTranslations, 'description', description);
  mergeTranslations(itemTranslations, 'title', title);

  return arrayTranslations(itemTranslations);
};

/**
 * Transforms EventTimelineFormData to Partial<EventTimelineGroupTranslationRequest[]>
 * @param eventTimelineGroupsResponse
 * @param values
 */
export const getEventTimelineDetailsTranslationsRequest = (
  eventTimelineGroupsResponse: EventTimelineGroupResponse[],
  values: EventTimelineFormData,
): Pick<EventTranslationRequest, 'eventTimelineGroupTranslationRequestItems'> => {
  if (isNilOrEmpty(eventTimelineGroupsResponse)) {
    return { eventTimelineGroupTranslationRequestItems: null };
  }

  const { eventTimelineGroups } = values;
  const timelineGroupTranslations: EventTimelineGroupTranslationRequest[] = eventTimelineGroupsResponse.map(
    (eventTimelineGroup: EventTimelineGroupResponse, index: number) => ({
      groupId: eventTimelineGroup.id,
      eventTimelineTranslationGroupRequestItems: getEventTimelineGroupTitleRequest(
        eventTimelineGroups[index].title,
      ),
      timelineTranslationRequests: eventTimelineGroups[index].eventTimelineItems.map(
        (item: EventTimelineItemFormData) => ({
          rank: item.rank,
          eventTimelineTranslationRequestItems: getEventTimelineTranslationRequestItems(item),
        }),
      ),
    }),
  );

  return {
    eventTimelineGroupTranslationRequestItems: timelineGroupTranslations,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-timeline-details-request.helper.ts